// 저장된 버핏 분석 목록 — 좌측 패널의 "저장된 분석".
//
// 서버에는 목록 API 가 없고 분석 결과만 7일 캐시된다. 그래서 "이 사용자가
// 무엇을 분석했는지"는 여기(localStorage, 사용자별 키)에 남기고, 항목을 다시
// 누르면 같은 종목으로 조회를 걸어 서버 캐시에서 즉시 되돌아온다.
// 사용자 구분 규칙은 labFiles 와 동일하다.
import { useAuth } from "../stores/auth";

export interface BuffettRecent {
  name: string;
  symbol: string;
  market: "kr" | "us";
  score: number;
  rating: string;
  asof: string;      // YYYY-MM-DD — 딥링크 스냅샷 복원용
  created: string;   // ISO
}

const LIMIT = 40;

function storeKey(): string {
  try {
    const u = useAuth.getState().user as Record<string, unknown> | null;
    const k = String(u?.uid || u?.username || u?.email || "_anon").toLowerCase();
    return `va_buffett_recent::${k}`;
  } catch {
    return "va_buffett_recent::_anon";
  }
}

export function buffettRecentList(): BuffettRecent[] {
  try {
    return JSON.parse(localStorage.getItem(storeKey()) || "[]") as BuffettRecent[];
  } catch {
    return [];
  }
}

export function recordBuffettRecent(r: Omit<BuffettRecent, "created">): void {
  try {
    const list = buffettRecentList();
    const prev = list.find((x) => x.symbol === r.symbol);
    // 목록은 만든 시각 순으로 고정한다 — 저장된 항목을 다시 열어보는 것만으로
    // 순서가 바뀌면 어디에 뭐가 있었는지 매번 다시 찾아야 한다. 분석일(asof)이
    // 그대로면 같은 분석을 다시 편 것이므로 만든 시각을 유지하고, 분석일이
    // 바뀌었으면(캐시 만료 후 재분석) 새로 만든 것이라 시각을 갱신한다.
    const created = prev && prev.asof === r.asof ? prev.created : new Date().toISOString();
    const next = [{ ...r, created }, ...list.filter((x) => x.symbol !== r.symbol)];
    next.sort((a, b) => (a.created < b.created ? 1 : a.created > b.created ? -1 : 0));
    localStorage.setItem(storeKey(), JSON.stringify(next.slice(0, LIMIT)));
  } catch {
    /* 기록 실패가 분석 흐름을 막지 않는다 */
  }
}
